import { render, staticRenderFns } from "./youtube-stream.vue?vue&type=template&id=66867ff2"
import script from "./youtube-stream.vue?vue&type=script&lang=ts&setup=true"
export * from "./youtube-stream.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports